// @ts-nocheck

import { createStructuredSelector } from 'reselect';

import { selectReviewIsDialogOpen } from '../../selectors/review/reviewPrimary.selector';
import { type Selector } from '../../types/selectors';

type ReviewPropsType = {
  isDialogOpen: boolean;
};

const selectReviewProps: Selector<ReviewPropsType> = createStructuredSelector({
  isDialogOpen: selectReviewIsDialogOpen,
});

export default selectReviewProps;
